export const organizationSetupSteps = [
  { title: "Select invoices" },
  { title: "Email preview" },
];

export const TOTAL_NUMBER_OF_STEPS = organizationSetupSteps.length;
